import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { Controller, useFormContext } from 'react-hook-form';

type FormDatePickerProps = RangePickerProps & {
  name: string;
};

export const FormDateRangePicker = ({ name, format, ...props }: FormDatePickerProps) => {
  const { control } = useFormContext();

  // eslint-disable-next-line
  const onChangeInternal = (date: any, dateString: [string, string], onChange: (...events: any[]) => void) => {
    if (!date) {
      onChange('');
      return;
    }
    onChange(date);
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <DatePicker.RangePicker
          format={format}
          value={value}
          onChange={(date, dateString) => onChangeInternal(date, dateString, onChange)}
          {...props}
        />
      )}
    />
  );
};
